import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle2, XCircle, Clock, Loader2 } from 'lucide-react';

const PURPOSE_ROUTES = {
  doctor_wallet: '/doctor/wallet',
  doctor_credit: '/doctor/wallet',
  patient_wallet: '/patient/wallet',
  vendor_wallet: '/vendor/dashboard'
};

export default function PaymentResultPage() {
  const navigate = useNavigate();
  const [params, setParams] = useState({ status: 'pending', purpose: '' });

  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    setParams({ status: q.get('status') || 'pending', purpose: q.get('purpose') || '' });
  }, []);

  const backPath = PURPOSE_ROUTES[params.purpose] || '/';

  const config = {
    success: {
      icon: <CheckCircle2 className="w-16 h-16 text-green-500" />,
      title: 'Payment Successful',
      message: 'Your payment was processed and your account has been credited.'
    },
    pending: {
      icon: <Clock className="w-16 h-16 text-amber-500" />,
      title: 'Payment Pending',
      message: 'Your payment is being processed. It will reflect shortly once confirmed by PayU.'
    },
    failed: {
      icon: <XCircle className="w-16 h-16 text-red-500" />,
      title: 'Payment Failed',
      message: 'Your payment could not be completed. Please try again.'
    },
    error: {
      icon: <XCircle className="w-16 h-16 text-red-500" />,
      title: 'Something Went Wrong',
      message: 'We could not verify this payment. If an amount was deducted, it will be reconciled automatically.'
    }
  };

  const view = config[params.status] || config.pending;

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="payment-result-page">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center space-y-4">
          <div className="flex justify-center">{view.icon}</div>
          <h1 className="text-xl font-bold" data-testid="payment-result-title">{view.title}</h1>
          <p className="text-sm text-slate-500">{view.message}</p>
          <Button className="w-full mt-2" onClick={() => navigate(backPath)} data-testid="payment-result-back-btn">
            Back to Wallet
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
